import { Outlet } from "react-router-dom";
import { Sidebar } from "@/features/dashboard/components/Sidebar";
import { MobileHeader } from "@/features/dashboard/components/MobileHeader";

export default function DashboardLayout() {
  return (
    <div data-testid="dashboard-shell" className="min-h-screen bg-background lg:grid lg:grid-cols-[272px_1fr]">
      <aside className="sticky top-0 hidden h-screen lg:block">
        <Sidebar />
      </aside>
      <MobileHeader />
      <main className="mx-auto w-full max-w-5xl px-5 py-10 sm:px-8 lg:px-14 lg:py-16">
        <Outlet />
      </main>
    </div>
  );
}
